module.exports = __webpack_public_path__ + "img/U_TalkBeforeAction.11526fa2.gif";